import { render, staticRenderFns } from "./ReportSectionDbcValuation.vue?vue&type=template&id=2dad940a&scoped=true&lang=html&"
import script from "./ReportSectionDbcValuation.vue?vue&type=script&lang=js&"
export * from "./ReportSectionDbcValuation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dad940a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VFlex,VIcon,VLayout,VProgressLinear})
